export default __webpack_public_path__ + "static/media/img06.883a5613.jpg";